import { useState } from "react";
import { toast } from "sonner";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Label } from "./ui/label";
import { Send } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ContactForm = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      toast.error("Please fill in every field.");
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${API}/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error("failed");
      toast.success("Message sent! We'll be in touch.");
      setForm({ name: "", email: "", message: "" });
    } catch {
      toast.error("Could not send. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="contact-form" className="space-y-5">
      <div className="grid sm:grid-cols-2 gap-5">
        <div>
          <Label htmlFor="c-name" className="text-xs uppercase tracking-[0.15em] text-muted-foreground">
            Name
          </Label>
          <Input
            id="c-name"
            data-testid="contact-name"
            value={form.name}
            onChange={set("name")}
            className="mt-1.5 bg-white/5 border-white/10 h-12"
            placeholder="Your name"
          />
        </div>
        <div>
          <Label htmlFor="c-email" className="text-xs uppercase tracking-[0.15em] text-muted-foreground">
            Email
          </Label>
          <Input
            id="c-email"
            data-testid="contact-email-input"
            type="email"
            value={form.email}
            onChange={set("email")}
            className="mt-1.5 bg-white/5 border-white/10 h-12"
            placeholder="you@email.com"
          />
        </div>
      </div>
      <div>
        <Label htmlFor="c-message" className="text-xs uppercase tracking-[0.15em] text-muted-foreground">
          Message
        </Label>
        <Textarea
          id="c-message"
          data-testid="contact-message"
          value={form.message}
          onChange={set("message")}
          rows={4}
          className="mt-1.5 bg-white/5 border-white/10 resize-none"
          placeholder="Tell us about your event, booking or collaboration..."
        />
      </div>
      <button
        type="submit"
        data-testid="contact-submit"
        disabled={loading}
        className="inline-flex items-center gap-2 bg-primary text-primary-foreground rounded-full px-8 py-3.5 font-medium hover:bg-white hover:text-black transition-colors duration-300 disabled:opacity-60"
      >
        <Send size={17} />
        {loading ? "Sending..." : "Send message"}
      </button>
    </form>
  );
};
